//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action

import * as guideAction from '../action/guideAction';

//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';

//Icon
import CloseIcon from '@material-ui/icons/Close';

import hnUnten from '../img/proof/hn-unten.jpg';
import hnUntenRotate from '../img/proof/hn-unten_rotate.png';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


class Comp extends React.Component {


	render() {

		return (
      <Dialog
        fullScreen
        open={this.props.guide.proofPerson.visible}
        onClose={ () => this.props.guideProofPersonSet(false) }
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
        scroll='paper'
      >
        <div style={{width:'100%',zIndex:'100'}} className='shadow'>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              厳重な本人確認
            </div>
            <div>
              <IconButton onClick={ () => this.props.guideProofPersonSet(false) }>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>
        <DialogContent style={{padding:'10px'}}>


          <div style={{margin:'15px'}}>
            <h2>厳重なご本人様証明確認の為、画像は２枚必要です。</h2>
            <div style={{fontSize:'0.9em',color:'#666'}}>
              不正業者を排除するため、証明書の情報以外に厚みなど細かいチェックを行なっております。
              安心安全の為、ご協力をお願いいたします。
            </div>
          </div>

          <div style={{margin:'15px'}}>
            <h3>まっすぐ正面からの画像</h3>
            <div  align='center' style={{padding:'10px', transformStyle:'preserve-3d', perspective:'800px'}}>

              <img
                src={hnUnten}
                style={{width:'80%', maxWidth:'240px', height:'auto'}}
                alt=""
              />

              <div align='center' style={{color:'red'}}>
                証明書を正面から画像を撮影してください
              </div>
            </div>
          </div>
          <div style={{margin:'15px'}}>
            <h3>前後に45度傾けた画像</h3>
            <div  align='center' style={{padding:'10px', transformStyle:'preserve-3d', perspective:'300px'}}>
              <img
                src={hnUntenRotate}
                style={{width:'80%', maxWidth:'240px', height:'auto'}}
                alt=""
              />
              <div align='center' style={{color:'red'}}>
                同じ証明書を前後に45度程度傾けて<br/>
                画像を撮影してください
              </div>
            </div>
          </div>


        </DialogContent>
      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		guide: state.guide,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
